/** @format */

import template from './gb-edit-base-widget.html';
import './gb-edit-base-widget.scss';

export const GbEditBaseWidgetComponent = {
    template,
    require: {
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
        excludeFields: '<',
    },
    controller: class GbEditBaseWidgetComponent {
        constructor($ccLoading, LoadingHelper) {
            'ngInject';

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        getWidget() {
            return this.widget;
        }

        shouldShowField(fieldName) {
            return !!this.excludeFields ? this.excludeFields.indexOf(fieldName) === -1 : true;
        }

        onBaseWidgetBorderStyleChange() {
            const loader = this.loadingHelper.push('SAVING');
            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }
    },
};
